import Vue from 'vue'
import VueRouter from 'vue-router'
import registration from "@/registration"
import appConfigGlobal from "@/app.config.global"
import PageNotFound from "@/apps/fenceline/views/NotFound.vue"
import SiteList from "@/apps/fenceline/views/SiteList.vue"
import Report from "@/apps/fenceline/views/Report.vue"

const appRoutes = registration.map(e => e.route);

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'App',
    redirect: appConfigGlobal.defaultRouteRedirect,
  },
  {
    path: '/settings',
    name: 'User Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/_views/my/Settings.vue'),
  },
  {
    path: '/logins',
    name: 'Logins',
    component: () => import(/* webpackChunkName: "Logins" */ '@/_views/my/Logins.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "About" */ '@/_views/about'),
  },
  { path: "*", component: PageNotFound },
  ...appRoutes
];

const router = new VueRouter({
  //mode: 'history',
  routes
  /*routes : [
    { path: "/Report", name: "Report", component: SiteList },
    { path: "/Report/cvo", name: "Report/cvo", component: Report },
    { path: "/Report/cco", component: Report },
    { path: "/Report/clo", component: Report },
    { path: "/Report/mio", component: Report },
    { path: "/Report/lpo", component: Report }
    // ... other routes ...
    // and finally the default route, when none of the above matches:
    //{ path: "*", component: PageNotFound }
]*/
})

export default router
